import { render } from "./MatchLoadouts.vue?vue&type=template&id=4955b8b4"
import script from "./MatchLoadouts.vue?vue&type=script&lang=js"
export * from "./MatchLoadouts.vue?vue&type=script&lang=js"

import "./MatchLoadouts.vue?vue&type=style&index=0&id=4955b8b4&lang=css"

import exportComponent from "C:\\Users\\windows\\Documents\\GitHub\\ValoAssist_web - 복사본\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__